import React, { useEffect, useState } from 'react'

import { yupResolver } from '@hookform/resolvers/yup'
import { Form, Col, Row, Button, InputMask, Grid, SelectForm } from 'components'
import { useModal, useLoading, useToggle } from 'hooks'
import { useForm } from 'react-hook-form'
import {
  MotivosBloqueioInterface,
  MotivoBloqueioServices,
  ITipoMotivoBloqueio
} from 'services/NGT/RecordsSheet'
import { COLORS, SPACING } from 'utils'
import * as yup from 'yup'

import { BlockTable } from './components/BlockTable/BlockTable'
import EditBlockModal from './components/EditBlockModal/EditBlockModal'

const schema = yup.object({
  tipoMotivoBloqueioId: yup.number().required('Informe tipo motivo'),
  txDescricao: yup.string().required('Informe a descrição'),
  txMotivo: yup.string().required('Informe o motivo')
})

const Block: React.FC = () => {
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors }
  } = useForm({ resolver: yupResolver(schema) })

  const { setLoading } = useLoading()
  const { showModal } = useModal()
  const [openBlockEditModal, toggleBlockEditModal] = useToggle()
  const [selectedMotivo, setSelectedMotivo] = useState<
    MotivosBloqueioInterface | undefined
  >()
  const [motivosBloqueio, setMotivosBloqueio] = useState<
    MotivosBloqueioInterface[]
  >([])

  const [tiposMotivoBloqueio, setTiposMotivoBloqueio] = useState<
    ITipoMotivoBloqueio[]
  >([])

  const handleSubmitForm = (formData: MotivosBloqueioInterface) => {
    setLoading('loading')

    MotivoBloqueioServices()
      .CreateMotivo(formData)
      .then(({ data }) => {
        if (data.sucesso) {
          showModal({
            hideButtonCancel: true,
            message: 'Dados salvos com sucesso!',
            txtButtonConfirm: 'Fechar',
            type: 'success'
          })

          getAllMotivosBloqueio()
          handleClearForm()
        }
      })
      .catch(() => {
        showModal({
          hideButtonCancel: true,
          message: 'Erro ao salvar motivo, tente novamente.',
          txtButtonConfirm: 'Fechar',
          type: 'error'
        })
      })
      .finally(() => {
        setLoading('idle')
      })
  }

  const handleClearForm = () => {
    reset({
      txDescricao: '',
      txMotivo: ''
    })
  }

  const getAllMotivosBloqueio = async () => {
    setLoading('loading')
    try {
      await MotivoBloqueioServices()
        .GetALL()
        .then(({ data }) => {
          setMotivosBloqueio(data)
        })
        .catch(() => {
          throw new Error('Erro ao buscar lista de motivos!')
        })
    } catch (error: any) {
      setLoading('idle')
      showModal({
        hideButtonCancel: true,
        message: 'Erro ao buscar lista de motivos!',
        txtButtonConfirm: 'Fechar',
        type: 'error'
      })
    }
    setLoading('idle')
  }

  const getTiposMotivoBloqueio = async () => {
    setLoading('loading')
    try {
      await MotivoBloqueioServices()
        .GetTipoMotivo()
        .then(({ data }) => {
          setTiposMotivoBloqueio(data)
        })
        .catch(() => {
          throw new Error('Erro ao buscar tipos de motivo bloqueio!')
        })
    } catch (error: any) {
      setLoading('idle')
      showModal({
        hideButtonCancel: true,
        message: 'Erro ao buscar tipos de motivo bloqueio!',
        txtButtonConfirm: 'Fechar',
        type: 'error'
      })
    }
    setLoading('idle')
  }

  const handleSelectedMotivo = (currentMotivo: MotivosBloqueioInterface) => {
    setSelectedMotivo(currentMotivo)
    toggleBlockEditModal()
  }

  const handleUpdateMotivoBloqueio = async (data: MotivosBloqueioInterface) => {
    setLoading('loading')

    const requestObj = {
      idMotivoBloqueio: data.idMotivoBloqueio,
      tipoMotivoBloqueioId: data.tipoMotivoBloqueioId,
      txDescricao: data.txDescricao,
      txMotivo: data.txMotivo
    }

    MotivoBloqueioServices()
      .UpdateMotivo(requestObj)
      .then((response) => {
        if (response.status === 200) {
          showModal({
            hideButtonCancel: true,
            message: 'Dados salvos com sucesso!',
            txtButtonConfirm: 'Fechar',
            type: 'success'
          })
          getAllMotivosBloqueio()
        }
        setLoading('idle')
      })
      .catch(() => {
        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message: 'Não foi possível salvar os dados!',
          txtButtonConfirm: 'Fechar',
          type: 'error'
        })
      })
    setSelectedMotivo(undefined)
  }

  const handleDeleteMotivo = (idMotivoBloqueio: number) => {
    setLoading('loading')

    MotivoBloqueioServices()
      .DeleteMotivo(idMotivoBloqueio)
      .then((response) => {
        if (response.status === 200) {
          showModal({
            hideButtonCancel: true,
            message: 'Deletado com sucesso!',
            txtButtonConfirm: 'Fechar',
            type: 'success'
          })
          getAllMotivosBloqueio()
        }
      })
      .catch((error) => {
        showModal({
          hideButtonCancel: true,
          message: 'Erro ao deletar motivo, tente novamente!',
          txtButtonConfirm: 'Fechar',
          type: 'error'
        })
      })
      .finally(() => {
        setLoading('idle')
      })
  }

  useEffect(() => {
    getAllMotivosBloqueio()
    getTiposMotivoBloqueio()
  }, [])

  return (
    <>
      <Form
        onSubmit={handleSubmit(handleSubmitForm)}
        marginLeft={SPACING.spacing20}
        marginRight={SPACING.spacing20}
        marginBottom={SPACING.spacing100}
        padding={SPACING.spacing20}
        boxShadow={`0 0 1em ${COLORS.lightGray}`}
      >
        <Grid
          gridCols="6fr 2fr"
          gridGap={`0 ${SPACING.spacing20}`}
          margin={`${SPACING.spacing10} 0 ${SPACING.spacing10} 0`}
        >
          <Col gap="1.5rem">
            <InputMask
              control={control}
              errors={errors}
              label="Motivo"
              formValue="txMotivo"
              placeholder="Informe o motivo"
              maxLength={50}
              type="alfanumeric"
              required
            />
            <InputMask
              control={control}
              errors={errors}
              label="Descrição Motivo"
              formValue="txDescricao"
              placeholder="Informe a descrição"
              maxLength={100}
              type="cleanText"
              required
            />
            <SelectForm
              control={control}
              errors={errors}
              label="Tipo Motivo"
              formValue="tipoMotivoBloqueioId"
              placeholder="Selecione"
              listOptions={tiposMotivoBloqueio}
              labelMenu="txTipo"
              valueMenu="idTipoMotivoBloqueio"
            />
          </Col>
        </Grid>
        <Row justifyContent="flex-end" marginBottom={SPACING.spacing20}>
          <Button
            text="Limpar"
            variantButton="outlined"
            marginRight={SPACING.spacing20}
            onClick={() => handleClearForm()}
          />
          <Button text="Salvar" type="submit" />
        </Row>
        <BlockTable
          tableData={motivosBloqueio}
          handleEditMotivo={handleSelectedMotivo}
          handleDeleteMotivo={handleDeleteMotivo}
        />
      </Form>
      <EditBlockModal
        showEditModal={openBlockEditModal}
        toggleModal={toggleBlockEditModal}
        blockData={selectedMotivo}
        handleSubmitUpdate={handleUpdateMotivoBloqueio}
        tiposMotivoBloqueio={tiposMotivoBloqueio}
      />
    </>
  )
}

export default Block
